import { followUpScheduleInMinutes } from 'shared/legacy/contexts/CandidateContext/actions/nowPlusXMinutes';
import { useFeatureToggles } from 'shared/legacy/hooks/useFeatureToggles';

const TWO_DAYS_IN_MINUTES = 2 * 24 * 60;
const FIVE_DAYS_IN_MINUTES = 5 * 24 * 60;

export const useFollowUpSchedule = () => {
  const { getFeatureToogleValue } = useFeatureToggles();

  return () => {
    return [
      followUpScheduleInMinutes(
        getFeatureToogleValue((f) => f.FIRST_FOLLOW_UP_IN_MINUTES),
        TWO_DAYS_IN_MINUTES,
      ),
      followUpScheduleInMinutes(
        getFeatureToogleValue((f) => f.SECOND_FOLLOW_UP_IN_MINUTES),
        FIVE_DAYS_IN_MINUTES,
      ),
    ].filter((maybeDate) => !!maybeDate);
  };
};
